// removed by extract-text-webpack-plugin
module.exports = {"root":"root_2uI2j","header":"header_rT9Jp","row":"row_3Rv5I","rowItem":"rowItem_3NMq_","rowDate":"rowDate_35jwq","rowItemLink":"rowItemLink_a8eqr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/style.css
// module id = 208
// module chunks = 0